import { Box, Grid, Toolbar, Typography } from "@mui/material"
import React, { useContext, useMemo } from "react"
import { customPalette, theme } from "../../../../theme"
import { BSVariantContext } from "../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { BSBuildingContext } from "../../../pages/projects/project/beem-shot/variant/building/components/context/BSBuildingContext"
import { BackButtonNavbar } from "../../buttons/back-button/BackButtonNavbar"
import { StepHeader } from "./StepHeader"

export function BSBuildingNavbar(): React.JSX.Element {
  const { selectedVariant } = useContext(BSVariantContext)
  const { selectedBSBuilding } = useContext(BSBuildingContext)

  const steps = useMemo(() => {
    if (selectedBSBuilding === undefined) {
      return []
    }
    if (selectedBSBuilding?.bim === true) {
      return ["Informations", "Choix de la maquette", "Parking", "Niveaux et Zones", "Fondations"]
    } else {
      return ["Informations", "Morphologie", "Parking", "Niveaux et Zones", "Patios", "Fondations"]
    }
  }, [selectedBSBuilding])

  return (
    <Toolbar
      sx={{
        color: customPalette.white,
        borderRadius: 5,
        backgroundColor: customPalette.dark1,
        ...theme.mixins.toolbar,
      }}>
      <Grid container alignItems="center">
        <Grid item xs={3} display="flex" flexDirection="row" alignItems="center">
          <BackButtonNavbar />

          <Box display="flex" flexDirection="column">
            <Typography fontSize={11} fontWeight={400}>
              {`${selectedVariant?.name} /`}
            </Typography>
            <Typography fontSize={16} fontWeight={600}>
              {`${selectedBSBuilding?.name ?? "Nouveau batiment"}`}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6} display="flex" justifyContent="center" alignContent="center">
          <StepHeader steps={steps} />
        </Grid>
      </Grid>
    </Toolbar>
  )
}
